module.exports = __webpack_public_path__ + "static/media/wrestling.7341c345.svg";